import { Box, type BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import { selectIsLocalRefill } from "slices/transactionSlice";
import { getBackgroundColor } from "utils/utils";

export type BlurredBackgroundProps = {
	orderStep: number;
	open: boolean;
	isMobilePayment?: boolean;
};

const StyledBlurredBackground = styled(Box, {
	shouldForwardProp: (prop) =>
		prop !== "orderStep" && prop !== "open" && prop !== "isMobilePayment" && prop !== "isRefill",
})<BoxProps & BlurredBackgroundProps & { isRefill: boolean }>(({ theme, orderStep, isRefill }) => ({
	position: "absolute",
	top: 0,
	left: 0,
	zIndex: -1,
	minWidth: "100%",
	minHeight: "100%",
	backgroundColor: orderStep === 1 ? "unset" : getBackgroundColor(orderStep, theme, isRefill),
	backdropFilter: "blur(20px)",
	borderRadius: "24px 24px 0 0",
}));

// Reads the refill flag itself: the drawer and every step's closed peek render this background, and a
// flag passed at each call site could leave the two layers in different colours.
export const BlurredBackground = (props: BoxProps & BlurredBackgroundProps) => {
	const isRefill = useAppSelector(selectIsLocalRefill);
	return <StyledBlurredBackground {...props} isRefill={isRefill} />;
};
